


  import dep0 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep1 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep2 from "ember-modifier/-embroider-implicit-modules.js";
  import dep3 from "ember-primitives/-embroider-implicit-modules.js";
  import dep4 from "ember-repl/-embroider-implicit-modules.js";
  import dep5 from "ember-resources/-embroider-implicit-modules.js";
  import dep6 from "reactiveweb/-embroider-implicit-modules.js";
  import dep7 from "tracked-built-ins/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
  {
  }
);
